import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PatientTransfer, TransferOrganization } from 'app/common/model/patient-transfer';

@Component({
    selector: 'mc-patient-transfer-preview',
    templateUrl: './patient-transfer-preview.component.html',
    styleUrls: ['./patient-transfer-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PatientTransferPreviewComponent implements OnInit {
  isRequestDisplayMode = false;

  @Input()  patientTransferInputList: PatientTransfer;

  constructor() { }

  ngOnInit() {

  }

    /**
     * True if the link should be displayed as active
     */
    public isLinkActive(sectionItem: string): boolean {
      if (sectionItem === 'requests') {
        return !this.isRequestDisplayMode;
      }
      // default is false
      return this.isRequestDisplayMode;
    }

    /**
     * get site name
     * @param org 
     * @returns 
     */
    public getSiteName(org: TransferOrganization): string{
      if(org.siteLevel === "Treating Location" && org.fullName){
        return org.fullName;
      }

      return org.name;
    }

}
